<template>
  <div class="operateStep">
    <p class="title">{{ lang('注意事项') }}</p>
    <p class="name">
      {{ lang('为了确保您审核成功，请您在打款时仔细核对官方账号填写是否正确') }}
    </p>
    <p class="name">
      {{
        lang('请您务必在填汇款备注中填写您的驿站编码以便我们核对您的汇款信息')
      }}
    </p>
    <p class="name">
      {{ lang('充值金额无法退款') }}
    </p>
  </div>
</template>

<script lang="ts" setup>
import lang from '@/langs'
</script>

<style scoped lang="less">
.operateStep {
  background: #fff;
  padding: 19px 16px;
  .title {
    color: rgba(60, 60, 60, 1);
    font-size: 16px;
    font-weight: 500;
    margin-bottom: 24px;
  }
  .name {
    color: rgba(60, 60, 60, 1);
    font-size: 14px;
    margin-bottom: 10px;
  }
}
</style>
